export const OktaClientId = '0oa6avxblwc5lrjm2697'
export const ENV = 'lab2' as string
export const OVERSIGHT_ENV_NAME = 'oversight-lab'
export const GCS_ENV_NAME = 'lab2'
